const React = require("react");
import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
} from "reactstrap";
import CustomToggleList from "../RemoteTable/custom-toggle-list";
const SearchTable = props => {
  const {
    onSearchAllHandle,
    children,
    columnToggleProps,
    optionShowColumnHandel,
    listMultipleRowAction,
    rowSelected,
    loading,
    resetFilterHandle,
    isShowResetFilter,
  } = props;

  const inputSearch = useRef(null);
  const { t, i18n } = useTranslation("common");
  // Custom Toggle column modal
  const [modalToggleColumn, setModalToggleColumn] = useState(false);
  const toggleCustomModal = () => setModalToggleColumn(!modalToggleColumn);

  // Button tác vụ hàng loạt
  const [isOpenActions, setIsOpenActions] = useState(false);
  const toggleOpenActions = () => setIsOpenActions(!isOpenActions);

  // Delay when search all
  const [searchTerm, setSearchTerm] = useState(null);

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (searchTerm) {
        onSearchAllHandle(searchTerm.target.value);
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  return (
    <Row className="mb-2 justify-content-between">
      <div className="d-flex" style={{ width: "fit-content" }}>
        <div className="search-box me-2 d-inline-block">
          <div className="position-relative">
            <input
              ref={inputSearch}
              type="search"
              onChange={e => setSearchTerm(e)}
              className="form-control"
              placeholder=" "
            />
            <i
              className="bx bx-search-alt search-icon"
              style={{ color: "#50a5f1" }}
            />
          </div>
        </div>
        <div style={{ position: "relative" }}>
          <Button
            onClick={() => {
              onSearchAllHandle(inputSearch.current.value);
            }}
            disabled={loading}
            color="info"
            outline
            className="me-2"
          >
            {t("search")}
          </Button>
        </div>
        {/* Button tác vụ hàng loạt*/}
        {listMultipleRowAction?.length > 0 && (
          <ButtonDropdown
            className="me-2"
            isOpen={isOpenActions}
            toggle={toggleOpenActions}
            disabled={loading}
          >
            <DropdownToggle className="btn-label" caret color="success" outline>
              <i className="bx bx-receipt label-icon" />
              <span>{t("actionMultipleRows")}</span>
              <i
                style={{ marginLeft: "5px" }}
                className="mdi mdi-chevron-down"
              />
            </DropdownToggle>
            <DropdownMenu style={{ zIndex: 3, border: " 1px solid #808080d4" }}>
              {listMultipleRowAction.map((action, index) => {
                let isShow = action.isShow !== undefined ? action.isShow : true;
                if (isShow) {
                  return (
                    <DropdownItem
                      href="#"
                      key={index}
                      style={{ position: "relative" }}
                      disabled={action?.isDisabled || false}
                      className="d-flex gap-1 align-items-center"
                      onClick={() => {
                        if (action.isLoading) {
                          return;
                        }
                        action.onClick && action.onClick(rowSelected);
                      }}
                    >
                      {action.isLoading ? (
                        <React.Fragment>
                          <div
                            style={{ cursor: "not-allowed" }}
                            className="d-flex gap-1 align-items-center"
                          >
                            <Spinner color="primary" size="sm" />
                            {action.loadingText}
                          </div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {action.icon}
                          {action.text}
                        </React.Fragment>
                      )}
                      {/* {listMultipleRowAction.length !== index + 1 && (
                            <div
                              style={{
                                borderBottom: "1px solid #808080ad",
                                position: "absolute",
                                width: "90%",
                                bottom: 0,
                                left: 0,
                                marginLeft: "auto",
                                marginRight: "auto",
                                right: 0,
                              }}
                            ></div>
                          )} */}
                    </DropdownItem>
                  );
                } else {
                  return <React.Fragment key={index}></React.Fragment>;
                }
              })}
            </DropdownMenu>
          </ButtonDropdown>
        )}
        {children}
      </div>
      <div style={{ width: "fit-content" }} className={"d-flex gap-2"}>
        {isShowResetFilter && (
          <button
            type="button"
            className="btn btn-secondary"
            style={{
              paddingTop: "1px",
              lineHeight: "14px",
              paddingBottom: "1px",
              paddingLeft: "8px",
              paddingRight: "9px",
            }}
            onClick={() => {
              inputSearch.current.value = "";
              resetFilterHandle && resetFilterHandle();
            }}
          >
            <i
              className="mdi mdi-filter-remove-outline align-middle me-2"
              style={{ fontSize: "25px" }}
            ></i>
            <span style={{ fontSize: "14px" }}>Clear bộ lọc</span>
          </button>
        )}

        {/* Button ẩn/hiện cột */}
        <ButtonDropdown
          isOpen={modalToggleColumn}
          toggle={() => {
            toggleCustomModal();
          }}
          disabled={loading}
          className="btn-group"
        >
          <DropdownToggle
            title={t("showFilterColumn")}
            // className="btn btn-primary  dropdown-toggle"
            // tag="div"
            caret
            color="warning"
            outline
          >
            <i className="fas fa-filter" />
          </DropdownToggle>
          <DropdownMenu
            style={{ zIndex: 4, maxHeight: "63vh", overflow: "auto" }}
            className="dropdown-menu-end"
          >
            <CustomToggleList
              {...columnToggleProps}
              optionShowColumnHandel={optionShowColumnHandel}
            ></CustomToggleList>
          </DropdownMenu>
        </ButtonDropdown>
      </div>
    </Row>
  );
};

SearchTable.propTypes = {
  onSearchAllHandle: PropTypes.func,
  children: PropTypes.any,
  columnToggleProps: PropTypes.any,
  optionShowColumnHandel: PropTypes.func,
  listMultipleRowAction: PropTypes.array,
  rowSelected: PropTypes.array,
  loading: PropTypes.bool,
  resetFilterHandle: PropTypes.any,
  isShowResetFilter: PropTypes.bool,
};

export default SearchTable;
